/* eslint-disable react/prop-types */
import React from "react";
import dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsDown, faThumbsUp } from "@fortawesome/free-solid-svg-icons";

// Shared by the page's results table and the chart drill-down modal.
const conversationColumns = [
    {
        accessor: 'createdDate',
        Header: 'Created',
        isVisible: true,
        Cell: ({ value }) => dayjs(value).format("DD/MM/YYYY HH:mm:ss")
    },
    {
        accessor: 'knowledgeName',
        Header: 'Knowledge',
        isVisible: true,
    },
    {
        accessor: 'question',
        Header: 'Question',
        isVisible: true,
        Cell: ({ value }) => {
            return <span title={value} className="d-inline-block text-truncate" style={{ maxWidth: '350px' }}>{value}</span>
        }
    },
    {
        accessor: 'answer',
        Header: 'Answer',
        isVisible: true,
        Cell: ({ value }) => {
            return <span title={value} className="d-inline-block text-truncate" style={{ maxWidth: '350px' }}>{value}</span>
        }
    },
    {
        accessor: 'user',
        Header: 'User',
        isVisible: true,
    },
    {
        accessor: 'isPositive',
        Header: 'Rating',
        isVisible: true,
        Cell: ({ value }) => {
            let icon = null;
            let className = '';
            if (value == 1) {
                icon = faThumbsUp;
                className = 'text-success';
            }
            if (value == 0) {
                icon = faThumbsDown;
                className = 'text-danger';
            }
            return icon && <FontAwesomeIcon className={className} icon={icon} />
        }
    }
];

export default conversationColumns;
